import {
	SET_CURRENT_PAGE,
	SHOW_HIDDEN_PAGE
} from './actionTypes'

export function setCurrentPage(page) {
	return {
		type: SET_CURRENT_PAGE,
		page
	}
}

export function showHiddenPage() {
	return {
		type: SHOW_HIDDEN_PAGE
	}
}